import React from 'react';
import  { useState, useRef, useEffect, useCallback } from 'react';

import styles from './chatbot.module.css';
import exported from './chatbotfuncionality';
import SVGstorage from './SVGchatmanager';
import ReactMarkdown from 'react-markdown';

const Chatbot=()=>{
    //vars
    const [open, setOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [datachatuser, setDatachatuser] = useState([]);
    const [isloading, setIsloading] = useState(false);
    const [ip, setIp] = useState('');
    const [input, setInput] = useState('');
     // set the ref
     const messagesEndRef = useRef(null);
     //listener input changes 
     const handleInputChange = (e) => {
        setInput(e.target.value);
        e.preventDefault();
    }
    function getUserdata(user){

        if (user==='indurama'){
            if (input.trim()==='') return;
            setDatachatuser((prevMessages) => [...prevMessages, userMessage]);
            setInput('');
            const userMessage = {
                sender: styles.user,
                text: input
            };
        }
    }

    useEffect(() => {
        if(show){
            exported.get_id().then(ip=>setIp(String(ip)));
        }
    
      })
    
      const Handlesubmit=useCallback(()=>{
        setIsloading(true);
        getUserdata('indurama');
        const data={sessionId:"chat", action: "sendMessage", chatInput:input}
    
        exported.fetch_post("https://uroboro.app.n8n.cloud/webhook/indu",data)
        .then(tex=>{setTimeout(()=>{
    
            const botMessage = {
                sender: styles.bot,
                text: tex
            };
    
            setDatachatuser((prevMessages)=>[...prevMessages, botMessage]);
    
        },1)})
        .finally(()=>setIsloading(false));})

        useEffect(() => {
            if(messagesEndRef.current){
                messagesEndRef.current.scrollIntoView
                ({behavior: "smooth"});
            }
    
       }, [datachatuser]); 
       const keydownhandler=event=>{

        if(event.key==='Enter'){
            event.preventDefault();
            Handlesubmit();
        }
   }
   const showpopup=()=>{setShow(!show);}
   const toglledoctor=()=>{setOpen(!open); setShow(false);} 
   return (
    <>
    <button className={styles.fbutton}
            onMouseDown={toglledoctor}>
            {SVGstorage('IA')}
     </button>     
    {/** Slide chat agents */}
     {
        open? 
        <>
        <div className={styles.doctors}> 
        <button className={styles.fbutton}  onClick={showpopup}>
            {SVGstorage('chatbutton')}
        </button>            
        </div>

        </>:''
     }   
     

     {/** Chatbot */}
     {show?  
        <div className={styles.popup}>
            <section className={styles.title}> 
                <h3>Audiostories AI <span> {SVGstorage('online')} </span>  </h3>
             </section>
            <section  className={styles.textres} > 

                <div className={styles.chatcontainer}>
                        {datachatuser.map((message,index)=>{

                            if (message.sender===styles.bot) {
                                return(
                                    
                                    <div key={index} className={message.sender} >

                                        <p> <ReactMarkdown>{message.text}</ReactMarkdown>  </p>


                                    </div>


                                )
                                
                            }

                            return(

                                <div key={index} className={message.sender}>

                                    <p>
                                        <span>
                                            {message.text}        
                                        </span>    
                                    </p>


                                </div>
                            )



                        })}

                        {isloading? <div className={styles.loader}></div>  :''}  

                        <div ref={messagesEndRef}></div>

                </div>
            </section>
            <section id={styles.inputdr} className={styles.container} >

                <div className={styles.inputwrapper}>

                    <input type="text"
                        value={input}
                        onChange={handleInputChange}
                        onKeyDown={keydownhandler}
                        disabled={isloading}
                        placeholder="Type a message"
                        className={styles.messageInput}                            
                            />
                     <div className={styles.actionbuttons}>
                        <button className={styles.sendButton}
                            onClick={Handlesubmit}
                            disabled={isloading}>
                            {SVGstorage('send')}    
                        </button>
                        
                       </div>       

                </div>

        
             </section>



        </div> :''}
    </>

     
);



}

export default Chatbot